"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/camelcase */
const sdk_1 = require("@cosmwasm/sdk");
const bcp_1 = require("@iov/bcp");
const encoding_1 = require("@iov/encoding");
const address_1 = require("./address");
const caip5_1 = require("./caip5");
const decode_1 = require("./decode");
const encode_1 = require("./encode");
const types_1 = require("./types");
class CosmWasmCodec {
    constructor(addressPrefix, bankTokens, erc20Tokens = []) {
        this.addressPrefix = addressPrefix;
        this.bankTokens = bankTokens;
        this.erc20Tokens = erc20Tokens;
    }
    bytesToSign(unsigned, nonce) {
        const built = encode_1.buildUnsignedTx(unsigned, this.bankTokens, this.erc20Tokens);
        const signBytes = sdk_1.makeSignBytes(built.value.msg, built.value.fee, caip5_1.Caip5.decode(unsigned.chainId), built.value.memo || "", types_1.nonceToAccountNumber(nonce), types_1.nonceToSequence(nonce));
        return {
            bytes: signBytes,
            prehashType: bcp_1.PrehashType.Sha256,
        };
    }
    // PostableBytes are JSON-encoded StdTx
    bytesToPost(signed) {
        // TODO: change this as well (return StdTx, not AminoTx)?
        const built = encode_1.buildSignedTx(signed, this.bankTokens, this.erc20Tokens);
        return sdk_1.marshalTx(built.value);
    }
    // TODO: this needs some marshalling going on...
    // Do we need to support this??
    identifier(_signed) {
        throw new Error("Not yet implemented, requires amino encoding- talk to Ethan");
        // const bytes = this.bytesToPost(signed);
        // const hash = new Sha256(bytes).digest();
        // return toHex(hash).toUpperCase() as TransactionId;
    }
    parseBytes(bytes, chainId, nonce) {
        if (nonce === undefined) {
            throw new Error("Nonce is required");
        }
        const parsed = sdk_1.unmarshalTx(bytes);
        return decode_1.parseSignedTx(parsed, chainId, nonce, this.bankTokens, this.erc20Tokens);
    }
    identityToAddress(identity) {
        return address_1.pubkeyToAddress(identity.pubkey, this.addressPrefix);
    }
    isValidAddress(address) {
        try {
            const { prefix, data } = encoding_1.Bech32.decode(address);
            if (prefix !== this.addressPrefix) {
                return false;
            }
            return data.length === 20;
        }
        catch (_a) {
            return false;
        }
    }
}
exports.CosmWasmCodec = CosmWasmCodec;
//# sourceMappingURL=cosmwasmcodec.js.map